import { useTranslation } from "react-i18next";
import Link from "@/components/feature/LocaleLink";
import { NEWS } from "@/data/news";

export default function NewsSection() {
  const { t } = useTranslation();

  return (
    <section id="news" className="bg-background-100 py-24 md:py-32">
      <div className="max-w-7xl mx-auto px-4 md:px-10">
        <div className="flex flex-col md:flex-row md:items-end md:justify-between mb-10 gap-6" data-reveal>
          <div>
            <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-primary-100 text-primary-700 text-xs font-semibold tracking-wider mb-4">
              <i className="ri-megaphone-line"></i>
              LATEST NEWS
            </div>
            <h2 className="font-heading text-3xl md:text-5xl font-bold text-foreground-950">
              {t("news.heading")}
            </h2>
            <p className="text-foreground-600 mt-3 text-base">
              {t("news.sub")}
            </p>
          </div>
          <Link
            to="/notice"
            className="inline-flex items-center gap-2 px-5 py-3 rounded-md border border-background-300 text-foreground-800 font-medium hover:bg-foreground-950 hover:text-background-50 hover:border-foreground-950 transition-colors cursor-pointer whitespace-nowrap"
          >
            {t("news.viewall")}
            <i className="ri-arrow-right-line"></i>
          </Link>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-5" data-reveal data-reveal-stagger>
          {/* 홈에는 최신 4건만 (2열 격자에 맞춤). 전체 목록은 /notice */}
          {NEWS.slice(0, 4).map((n) => (
            <Link
              key={n.id}
              to={`/notice/${n.id}`}
              className="glow-card glow-card-light group bg-background-100 rounded-lg p-6 border border-background-200 hover:border-primary-400 hover:bg-background-50 transition-all cursor-pointer flex flex-col h-full"
            >
              <div className="flex items-center justify-between mb-4">
                <span
                  className={`inline-flex items-center gap-1 px-2.5 py-1 rounded-md text-xs font-semibold ${n.catColor}`}
                >
                  {t(n.catKey)}
                </span>
                <span className="text-xs text-foreground-500 font-label">
                  {n.date}
                </span>
              </div>
              <h3 className="font-heading font-bold text-lg text-foreground-950 mb-3 leading-snug">
                {t(n.titleKey)}
              </h3>
              <p className="text-sm text-foreground-600 leading-relaxed flex-1 line-clamp-3">
                {t(n.excerptKey)}
              </p>
              <div className="mt-5 pt-4 border-t border-background-200 flex items-center gap-2 text-primary-600 text-sm font-semibold group-hover:gap-3 transition-all">
                {t("news.more")}
                <i className="ri-arrow-right-line"></i>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}
